import { useRef, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { firestoreDB } from '../adapters/firestore'

import { AiFillGoogleSquare } from 'react-icons/ai';
import CarafemLogo from '../images/carafem.png'

import {
  AuthContainer,
  AuthForm,
  LogoContainer,
  MainTagline,
  Logo,
  Divider,
  Text,
  Line,
  DisplayText,
  TermsText,
  AuthError,
} from '../styles/authForm';
import logo from '../images/logo.svg';

import '../css/components/custom.css'

import InputField from './InputField';
import Button from './Button';

function SignUp() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const emailRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const passwordRef = useRef();

  const { signup, signInWithGoogle } = useAuth();

  const history = useHistory();

  const handleSignup = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    const firstName = firstNameRef.current.value;
    const lastName = lastNameRef.current.value;
    signup(email, password, firstName, lastName)
      .then((ref) => {
        setLoading(false);
        history.push('/');
        {/*firestoreDB.collection('users').doc("testUID".uid).set("testUID");*/}
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };

  const googleSignin = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    signInWithGoogle()
      .then((ref) => {
        setLoading(false);
        history.push('/');
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  };

  return (
    <AuthContainer>
    <LogoContainer>
      <Logo src={CarafemLogo} />
      <MainTagline> Birth control? Yeah, we do that. </MainTagline>
      {/*<Logo src={logo} alt="logo" />*/}
    </LogoContainer>

      <DisplayText>
        Sign up for a seamless birth control experience
      </DisplayText>

      <Button
        onClick={(e) => googleSignin(e)}
        color="#0095F6"
        icon={<AiFillGoogleSquare fontSize="1.1rem" color="#ffffff" />}
        text="Log in with Google"
      />

      <Divider>
        <Line />
        <Text>OR</Text>
        <Line />
      </Divider>

      <AuthForm onSubmit={(e) => handleSignup(e)}>
        <InputField
          inputPlaceholder="Email"
          inputType="email"
          labelText="Email"
          inputRequired={true}
          inputRef={emailRef}
        />

        <InputField
          inputPlaceholder="First Name"
          inputType="text"
          labelText="First Name"
          inputRequired={true}
          inputRef={firstNameRef}
        />

        <InputField
          inputPlaceholder="Last Name"
          inputType="text"
          labelText="Last Name"
          inputRequired={true}
          inputRef={lastNameRef}
        />

        {/* <InputField
          inputPlaceholder="Username"
          inputType="text"
          labelText="Username"
        /> */}

        <InputField
          inputPlaceholder="Password"
          inputType="password"
          labelText="Password"
          inputRequired={true}
          inputRef={passwordRef}
        />

        <Button
          disabled={loading}
          type="submit"
          color="#0095F6"
          text="Sign up"
        />

        {error && <AuthError>{error}</AuthError>}
      </AuthForm>

      <TermsText>
        By signing up, you agree to our Terms , Data Policy and Cookies Policy .
      </TermsText>
    </AuthContainer>
  );
}

export default SignUp;
